
import NoData from '@/components/NoData';
import styles from './index.less';
import { List, PullRefresh, Image, Dialog } from 'react-vant';
import { useRef, useState } from 'react';
import { getWechatPhone } from '@/service/banner';
import phoneyUrl from '@/assets/serves/p2.png';
import { useModel } from '@umijs/max';

const Convenient = (props: any) => {
  const { type } = props;

  const [WechatPhone , setWechatPhone ] = useState([]);
  const pageNum  = useRef(1);
  const {defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );

  const click = (item: any) => {
    console.log(item);
    Dialog.confirm({
      title: '',
      message: `${item.phone}`,
      confirmButtonText: '拨打',
      onCancel: () => console.log('cancel'),
      onConfirm: () => {
        window.location.href = `tel://${item.phone}`
      },
    })  
  };
 
  const [finished, setFinished] = useState<boolean>(false)

  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setWechatPhone ([])
 
    const data = await getWechatPhone({ pageNum: pageNum.current, pageSize: 10, communityId: defaultRoom?.communityId , type })
    const listData: any =  [...WechatPhone , ...data.rows]
    if (isRefresh || pageNum.current === 1) {
      setWechatPhone (data.rows); 
    } else {
      setWechatPhone (listData); 
    }
 
    if (data.rows.length === data.total || data.rows.length < 10 || !data.rows.length || data.total === 0) { // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1
      setFinished(false); // 仍有数据可加载，保持为false
    }
  }

  const onRefresh = async () => {
    pageNum.current = 1
    setFinished(true)
    setWechatPhone ([])
    onLoadRefresh(true)
  }


 
  return ( 
    <div className= {styles.convenient}>
      <PullRefresh onRefresh={onRefresh} >
        <List finished={finished} onLoad={onLoadRefresh} finishedText={!WechatPhone?.length ? '' : '没有更多了'} >
          {WechatPhone ?.length !== 0 ? (
            <>
              {WechatPhone .map((item: any) => (
                <div
                  onClick={() => click(item)}
                  className={styles['contentBox']}
                  key={item.sequenceNbr}
                >
                      <div className={styles.leftBox}>
                        <div className={styles.title}>
                          <section className={styles.text}>{item.title}:</section>
                          <section className={styles.phone}>{item.phone}</section>
                        </div>
                        
                        <div className={styles.box}>
                          <div className={styles['viewBox']}>
                            <div>工作时间：{ item.flag24h === '是' ? '24小时值班' : `${item.startTime}~${item.endTime}`}</div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.rightBox}>
                        <Image src={phoneyUrl} height={32} width={32} alt='图片' />
                      </div>
                  </div>
              ))}
            </>
          ) : (
            <NoData />
          )}
        </List>
      </PullRefresh>
    </div>
  )
}

export default Convenient